type Maybe<T> = T | null;

export function getNotNullableItems<T>(items?: Maybe<Array<Maybe<T>>> | null): T[] {
    return items?.filter((item): item is T => Boolean(item)) || [];
}
